/* EVARIELLE — scroll reveal without external libraries */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function prepare() {
    var selectors = [
      'main section',
      '.shopify-section',
      '.product-card',
      '.collection-card',
      '.rich-text',
      '.image-with-text',
      '.multicolumn',
      '.slideshow'
    ];

    var nodes = document.querySelectorAll(selectors.join(','));
    nodes.forEach(function (el, index) {
      if (el.dataset.evaAnimated === 'true') return;
      if (!el.textContent.trim() && !el.querySelector('img')) return;
      el.dataset.evaAnimated = 'true';
      el.classList.add('eva-reveal');
      if (index % 4 === 1) el.classList.add('eva-reveal-delay-1');
      if (index % 4 === 2) el.classList.add('eva-reveal-delay-2');
      if (index % 4 === 3) el.classList.add('eva-reveal-delay-3');
    });

    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.eva-reveal').forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepare);
  else prepare();
})();
